/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbProjetFinancementGridDto } from './FcbProjetFinancementGridDto';
import {
    FcbProjetFinancementGridDtoFromJSON,
    FcbProjetFinancementGridDtoFromJSONTyped,
    FcbProjetFinancementGridDtoToJSON,
} from './FcbProjetFinancementGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbProjetFinancementGridDtoPaginatedResults
 */
export interface FcbProjetFinancementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbProjetFinancementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbProjetFinancementGridDto>}
     * @memberof FcbProjetFinancementGridDtoPaginatedResults
     */
    results?: Array<FcbProjetFinancementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbProjetFinancementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbProjetFinancementGridDtoPaginatedResults interface.
 */
export function instanceOfFcbProjetFinancementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbProjetFinancementGridDtoPaginatedResultsFromJSON(json: any): FcbProjetFinancementGridDtoPaginatedResults {
    return FcbProjetFinancementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbProjetFinancementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbProjetFinancementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbProjetFinancementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbProjetFinancementGridDtoPaginatedResultsToJSON(value?: FcbProjetFinancementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbProjetFinancementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

